import {defineMessages} from 'react-intl';
import moment from 'moment-timezone';

const messages = defineMessages({
    requiredField: {
        id: 'join.errors.required_field',
        defaultMessage: 'Поле обязательно для заполнения'
    },
    loginRequirements: {
        id: 'join.errors.login_requirements',
        defaultMessage: 'Минимум 4 символа, только латинские буквы и цифры'
    },
    passwordsNotEqual: {
        id: 'join.errors.passwords_not_equal',
        defaultMessage: 'Пароли не совпадают'
    },
    invalidEmail: {
        id: 'join.errors.email_invalid',
        defaultMessage: 'E-mail указан неверно'
    },
    invalidDate: {
        id: 'join.errors.date_invalid',
        defaultMessage: 'Дата рождения указана неверно'
    },
    invalidPhone: {
        id: 'join.errors.phone_invalid',
        defaultMessage: 'Номер телефона указан неверно'
    },
    ageIncorrect: {
        id: 'join.errors.age_incorrect',
        defaultMessage: 'Дата рождения указана неверно'
    },
    ageIllegal: {
        id: 'join.errors.age_illegal',
        defaultMessage: 'Недопустимый возраст'
    },
    invalidPromo: {
        id: 'join.errors.promo_length_error',
        defaultMessage: 'Максимум 4 символа'
    }
});

const KZ_COUNTRY_ID = 79;
const KZ_AGE_RESTRICTION = 21;
const OTHER_AGE_RESTRICTION = 18;

const RegistrationFormValidation = function(values) {
    let errors = {};

    const loginRegex = /^[a-zA-Z0-9]{4,20}/;
    const emailRegex = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;

    if (!values.login || !values.login.length) {
        errors.login = messages.requiredField;
    }

    if (loginRegex.test(values.login) === false) {
        errors.login = messages.loginRequirements;
    }

    if (!values.password || !values.password.length) {
        errors.password = messages.requiredField;
    }

    if (!values.passwordRepeat || !values.passwordRepeat.length) {
        errors.passwordRepeat = messages.requiredField;
    }

    if (values.password && values.passwordRepeat && values.passwordRepeat !== values.password) {
        errors.password = messages.passwordsNotEqual;
    }

    if (!values.firstName || !values.firstName.length) {
        errors.firstName = messages.requiredField;
    }

    if (!values.lastName || !values.lastName.length) {
        errors.lastName = messages.requiredField;
    }

    if (!values.dob) {
        errors.dob = messages.requiredField;
    } else if (values.dob && values.dob.indexOf('_') === -1) {
        const parsedDate = moment(values.dob, 'DD/MM/YYYY');

        if (!parsedDate.isValid()) {
            errors.dob = messages.invalidDate;
        } else if (parsedDate.isBefore('1900-01-01', 'year')) {
            errors.dob = messages.ageIncorrect;
        } else {
            const momentBefore = moment();
            if (KZ_COUNTRY_ID == values.countryId) {
                momentBefore.subtract(KZ_AGE_RESTRICTION, 'y');
            } else {
                momentBefore.subtract(OTHER_AGE_RESTRICTION, 'y');
            }

            if (!parsedDate.isBefore(momentBefore)) {
                errors.dob = messages.ageIllegal;
            }
        }
    } else if (values.dob && values.dob.indexOf('_') !== -1) {
        errors.dob = messages.invalidDate;
    }

    if (!values.email || !values.email.length) {
        errors.email = messages.requiredField;
    }

    if (emailRegex.test(values.email) === false) {
        errors.email = messages.invalidEmail;
    }

    if (!values.phone || !values.phone.length) {
    } else if (values.phone && values.phone.length && /\d+/g.test(values.phone) === true &&
        /^\d+$/.test(values.phone) === false) {
        errors.phone = messages.invalidPhone;
    }

    if (!values.accountResourceId) {
        errors.accountResourceId = messages.requiredField;
    }

    if (!values.timezoneId) {
        errors.timezoneId = messages.requiredField;
    }

    return errors;
};

export default RegistrationFormValidation;



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/regular/RegistrationFormValidation.js